import * as Actions from '../actions'

const initialState = {
  success: false,
  isSubmitting: false,
  error: {
    username: null,
    password: null,
  },
  isShowErrorPlanEnd: false,
}

const login = function (state = initialState, action) {
  switch (action.type) {
    case Actions.LOGIN: {
      return {
        ...state,
        isSubmitting: true,
      }
    }
    case Actions.LOGIN_SUCCESS: {
      return {
        ...initialState,
        success: true,
        isSubmitting: false,
      }
    }
    case Actions.LOGIN_ERROR: {
      return {
        success: false,
        error: action.payload,
        isSubmitting: false,
      }
    }
    case Actions.SHOW_ERROR_PLAN_END: {
      return {
        isShowErrorPlanEnd: true,
      }
    }
    case Actions.CLEAR_LOGIN_ERROR: {
      return {
        isShowErrorPlanEnd: false,
      }
    }

    default: {
      return state
    }
  }
}

export default login
